import * as Yup from 'yup';
import configBuilder from '../config-builder';
import catchApiFailure from '../catch-api-error';
import ApiFactory from '../../index';
import { normalizeJsonToApi } from '../../helpers';

const api = ApiFactory.getApi();

export const Schema = Yup.object().shape({
  email: Yup.string().email().required(),
  password: Yup.string().required(),
});

export const isValid = async (params) => await Schema.isValid(params);
export const validate = async (params) => Schema.validate(params);
export const getBody = (params) => {
  const req = Schema.cast(params);
  return normalizeJsonToApi(req);
};
export const url = () => `/v1/auth/login`;
export const execute = async (params) => api.post(
  url(params),
  getBody(params),
  configBuilder(params)
).catch(catchApiFailure);